<template>
    <ul class="tab_st03_sub2">
        <li v-for="tab in apartTab" :key="tab.code">
            <a href="javascript:void(0);" :class="[selectedAtTab == tab.code ? 'on': '']" @click.prevent="selectTab(tab)">{{ tab.name }}</a>
        </li>
    </ul>
</template>

<script>

import { mapGetters } from 'vuex';
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import { $_WC } from '@/confs/common.const.js';

export default {
    data() {
        return {
        }
    },
    watch: {
    },
    components: {
    },
    computed: {
        ...mapGetters({
            selectedLfcnvncTab: 'getSelectedLfcnvncTab',
            apartTab: 'getApartTab',
            selectedAtTab: 'getSelectedAtTab',
        }),
    },
    created() {
    },
    methods: {
        selectTab(tab) {
            this.$store.dispatch('SET_SELECTED_AT_TAB', tab.code);
        },
    },
    mixins: [naverMapShareMixins],
};
</script>
